import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {checkIsActive} from "../../../_helpers";
import {useTranslation} from "react-i18next";
//material:
import MenuIcon from "@material-ui/icons/Menu";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Popover from "@material-ui/core/Popover";
import ListAltIcon from "@material-ui/icons/ListAlt";
import SettingsIcon from "@material-ui/icons/Settings";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

//actions:
import {tracksActions} from "../../../../app/redux/Tracks/tracksRedux";
import {trackPageActions} from "../../../../app/redux/TrackPage/trackPageRedux";
import {queryActions} from "../../../../app/redux/Query/queryRedux";
import {checkPermission} from "../../../../app/redux_slices/contextSlice";
import {sendDataLayer} from "../../../../app/util/tagmanager";

const CollapsedMenu = () => {
    const location = useLocation();
    const {t} = useTranslation();

    //redux:
    //store:
    const contextSelector = useSelector(state => state.context);
    const tracks = useSelector(state => state.tracks.normalTracks);
    const isTrackPage = useSelector(state => state.layout.isTrackPage);
    const canUploadVideos = useSelector(state => checkPermission(state, `settings.viewMenuLink`));

    //actions:
    const dispatch = useDispatch();

    const getNormalTracks = () => dispatch(tracksActions.getNormalTracks());

    const clearTrackPage = () => dispatch(trackPageActions.clearTrackPage());
    const clearSearcher = () => dispatch(queryActions.clearSearcher());

    //local state:
    const [selectedTrackId, setSelectedTrackId] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(null);
    const [TrackpopoverOpen, setTrackpopoverOpen] = useState(null);

    useEffect(() => {
        if (tracks && !tracks[0]) getNormalTracks();
        setTrackId();
    }, []);

    const getMenuItemActive = (url, exact) => {
        return checkIsActive(location, url, exact) ? "menu-item-active" : "";
    };

    const setTrackId = () => {
        if (isTrackPage) {
            const numberInUrl = location.pathname.match(/\d+/) && location.pathname.match(/\d+/)[0];

            setSelectedTrackId(numberInUrl ? Number(numberInUrl) : null);
        } else {
            setSelectedTrackId(null);
        }
    };

    useEffect(() => {
        setTrackId();
    }, [isTrackPage, location.pathname]);

    const handleClick = event => {
        setPopoverOpen(event.currentTarget);
    };

    const handleClose = () => {
        setPopoverOpen(null);
        setTrackpopoverOpen(null);
    };

    const handleTracksClick = e => {
        setTrackpopoverOpen(TrackpopoverOpen ? null : e.currentTarget);
        setPopoverOpen(popoverOpen);
    };

    const handleTracksClose = () => {
        setTrackpopoverOpen(null);
        setPopoverOpen(null);
    };

    let open = Boolean(popoverOpen);
    let openTrackPop = Boolean(TrackpopoverOpen);

    const id = open ? "simple-popover" : undefined;
    const trackPopId = openTrackPop ? "track-popover" : undefined;

    return (
        <div className="d-flex d-lg-none align-items-center h-100">
            <div className="d-flex cursor-pointer py-4" onClick={handleClick}>
                <MenuIcon
                    className={`text-muted text-hover-white ${
                        open ? "text-white" : ""
                    } font-size-1_8rem icon_svg_custom`}
                />
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={popoverOpen}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <div className="collapsed_menu_list">
                    <ul>
                        <li onClick={handleTracksClick} className="tracks_toggle">
                            <div className="d-flex">
                                <ListAltIcon/>
                                <span className="mx-3">{t("GENERAL.TRACKS")}</span>
                                <span>{openTrackPop ? <ExpandLess/> : <ExpandMore/>}</span>
                            </div>

                            <Popover
                                id={trackPopId}
                                open={openTrackPop}
                                anchorEl={TrackpopoverOpen}
                                onClose={handleTracksClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                            >
                                <div className="collapsed_menu_list tracks_list">
                                    <ul>
                                        {tracks && tracks[0] && tracks[0].name ? (
                                            tracks.map(track => (
                                                <li
                                                    key={track.track_id}
                                                    className={`${selectedTrackId === track?.track_id ? "active" : ""}`}
                                                >
                                                    <a
                                                        className="d-flex w-100 h-100"
                                                        href={`/track/${track?.track_id}`}
                                                        onClick={() => {
                                                            clearSearcher();
                                                            clearTrackPage();
                                                        }}
                                                    >
                                                        <span>{track.name}</span>
                                                    </a>
                                                </li>
                                            ))
                                        ) : (
                                            <li>{t("HEADER.BUTTON.TRACKS.PLACEHOLDER")}</li>
                                        )}
                                    </ul>
                                </div>
                            </Popover>
                        </li>
                        {canUploadVideos ? (
                            <li className={`${getMenuItemActive("/adminpanel") ? "active" : ""} d-flex`}>
                                <a href="/adminpanel" className="d-flex h-100 w-100">
                                    <SettingsIcon/> <span className="ml-3">{t("HEADER.BUTTONTEXT.ADMINPANEL")}</span>
                                </a>
                            </li>
                        ) : null}
                        <li className={`${getMenuItemActive("/profile") ? "active" : ""} d-flex`}>
                            <a href="/profile" className="d-flex h-100 w-100">
                                <AssignmentIndIcon/> <span className="ml-3">{t("HEADER.BUTTONTEXT.PROFILE")}</span>
                            </a>
                        </li>
                        <li className="d-flex logout_button" onClick={() => {
                            sendDataLayer(
                                {
                                    event: "session_logout",
                                },
                                {context: contextSelector},
                            )
                            dispatch({type: "CLEAR_STORE"});
                        }}>
                            <ExitToAppIcon/>
                            <span className="ml-3">{t("HEADER.BUTTON.LOGOUT")}</span>
                        </li>
                    </ul>
                </div>
            </Popover>
        </div>
    );
};

export default CollapsedMenu;

// import React, {useEffect, useState} from "react";
// import {useLocation} from "react-router-dom";
// import {useDispatch, useSelector} from "react-redux";
// import {checkIsActive} from "../../../_helpers";
// import {useTranslation} from "react-i18next";
// //material:
// import MenuIcon from "@material-ui/icons/Menu";
// import ExpandLess from "@material-ui/icons/ExpandLess";
// import ExpandMore from "@material-ui/icons/ExpandMore";
// import Popover from "@material-ui/core/Popover";
// import ListAltIcon from "@material-ui/icons/ListAlt";
// import SettingsIcon from "@material-ui/icons/Settings";
// import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
// import ExitToAppIcon from "@material-ui/icons/ExitToApp";
//
// //actions:
// import {tracksActions} from "../../../../app/redux/Tracks/tracksRedux";
// import {trackPageActions} from "../../../../app/redux/TrackPage/trackPageRedux";
// import {queryActions} from "../../../../app/redux/Query/queryRedux";
// import {checkPermission, loadParameter} from "../../../../app/redux_slices/contextSlice";
// import {sendDataLayer} from "../../../../app/util/tagmanager";
// import CloseIcon from "@material-ui/icons/Close";
//
// const CollapsedMenu = () => {
//         const location = useLocation();
//         const {t} = useTranslation();
//
//         //redux:
//         //store:
//         const contextSelector = useSelector(state => state.context);
//         const tracks = useSelector(state => state.tracks.normalTracks);
//         const isTrackPage = useSelector(state => state.layout.isTrackPage);
//         const canUploadVideos = useSelector(state => checkPermission(state, `settings.viewMenuLink`));
//         const corporativeLogo = useSelector(state => loadParameter(state, "corporativeLogo"));
//
//         //actions:
//         const dispatch = useDispatch();
//
//         const getNormalTracks = () => dispatch(tracksActions.getNormalTracks());
//
//         const clearTrackPage = () => dispatch(trackPageActions.clearTrackPage());
//         const clearSearcher = () => dispatch(queryActions.clearSearcher());
//
//         //local state:
//         const [selectedTrackId, setSelectedTrackId] = useState(null);
//         const [popoverOpen, setPopoverOpen] = useState(null);
//         const [TrackpopoverOpen, setTrackpopoverOpen] = useState(null);
//
//         useEffect(() => {
//             if (tracks && !tracks[0]) getNormalTracks();
//             setTrackId();
//         }, []);
//
//         const getMenuItemActive = (url, exact) => {
//             return checkIsActive(location, url, exact) ? "menu-item-active" : "";
//         };
//
//         const setTrackId = () => {
//             if (isTrackPage) {
//                 const numberInUrl = location.pathname.match(/\d+/) && location.pathname.match(/\d+/)[0];
//
//                 setSelectedTrackId(numberInUrl ? Number(numberInUrl) : null);
//             } else {
//                 setSelectedTrackId(null);
//             }
//         };
//
//         useEffect(() => {
//             setTrackId();
//         }, [isTrackPage, location.pathname]);
//
//         const handleClick = event => {
//             setPopoverOpen(!popoverOpen);
//         };
//
//         const handleClose = () => {
//             setPopoverOpen(null);
//             setTrackpopoverOpen(null);
//         };
//
//         const handleTracksClick = e => {
//             setTrackpopoverOpen(TrackpopoverOpen ? null : e.currentTarget);
//             setPopoverOpen(popoverOpen);
//         };
//
//         const handleTracksClose = () => {
//             setTrackpopoverOpen(null);
//             setPopoverOpen(null);
//         };
//
//         let open = Boolean(popoverOpen);
//         let openTrackPop = Boolean(TrackpopoverOpen);
//
//         const trackPopId = openTrackPop ? "track-popover" : undefined;
//
//         const onClickLogout = () => {
//             sendDataLayer(
//                 {
//                     event: "session_logout",
//                 },
//                 {context: contextSelector},
//             );
//             dispatch({type: "CLEAR_STORE"});
//         };
//
//         const style = {
//             floating: {
//                 position: "fixed",
//                 background: "#222222",
//                 width: "100vw",
//                 height: "100vh",
//                 padding: 0,
//                 left: 0,
//                 right: 0,
//                 top: 0,
//                 bottom: 0,
//                 display: "flex",
//                 alignItems: "center",
//                 flexDirection: "column",
//             },
//             logo: {
//                 height: 65,
//                 width: 115,
//                 backgroundImage: `url(${corporativeLogo || "/media/logos/winnow-white.png"})`,
//                 backgroundSize: "contain",
//                 backgroundRepeat: "no-repeat",
//                 backgroundPosition: "center center",
//                 marginLeft: 20,
//             },
//             navbar: {
//                 height: 65,
//             },
//         };
//         return (
//             <div className="d-flex d-lg-none align-items-center h-100">
//                 <div className="btn btn-hover-transparent-white h-45px w-45px my-auto ml-2" onClick={handleClick}>
//                     <MenuIcon
//                         className={`text-muted text-hover-white ${
//                             open ? "text-white" : ""
//                         } font-size-1_8rem icon_svg_custom`}
//                     />
//                 </div>
//                 {popoverOpen ?
//                     <div style={style.floating}>
//                         <div className={`w-100 d-flex justify-content-between`} style={style.navbar}>
//                             <div style={style.logo} />
//                             <button className={"btn btn-hover-transparent-white btn-light m-3 mr-5"} onClick={handleClick}>
//                                 <CloseIcon className="text-muted m-auto text-hover-white font-size-1_8rem" />
//                             </button>
//                         </div>
//                         <div class="list-group list-group-flush w-100">
//                             <button onClick={handleTracksClick} class="list-group-item list-group-item-action active"
//                                     aria-current="true">
//                                 <div className="d-flex">
//                                     <ListAltIcon />
//                                     <span className="mx-3">{t("GENERAL.TRACKS")}</span>
//                                     <span>{openTrackPop ? <ExpandLess /> : <ExpandMore />}</span>
//                                 </div>
//                                 <Popover
//                                     id={trackPopId}
//                                     open={openTrackPop}
//                                     anchorEl={TrackpopoverOpen}
//                                     onClose={handleTracksClose}
//                                     anchorOrigin={{
//                                         vertical: "bottom",
//                                         horizontal: "left",
//                                     }}
//                                     transformOrigin={{
//                                         vertical: "top",
//                                         horizontal: "right",
//                                     }}
//                                 >
//                                     <div className="collapsed_menu_list tracks_list">
//                                         <ul>
//                                             {tracks && tracks[0] && tracks[0].name ? (
//                                                 tracks.map(track => (
//                                                     <li
//                                                         key={track.track_id}
//                                                         className={`${selectedTrackId === track?.track_id ? "active" : ""}`}
//                                                     >
//                                                         <a
//                                                             className="d-flex w-100 h-100"
//                                                             href={`/track/${track?.track_id}`}
//                                                             onClick={() => {
//                                                                 clearSearcher();
//                                                                 clearTrackPage();
//                                                             }}
//                                                         >
//                                                             <span>{track.name}</span>
//                                                         </a>
//                                                     </li>
//                                                 ))
//                                             ) : (
//                                                 <li>{t("HEADER.BUTTON.TRACKS.PLACEHOLDER")}</li>
//                                             )}
//                                         </ul>
//                                     </div>
//                                 </Popover>
//                             </button>
//                             {canUploadVideos ? (
//                                 <a href="/adminpanel"
//                                    class={`list-group-item list-group-item-action${getMenuItemActive("/adminpanel") ? " active" : ""}`}>
//                                     <SettingsIcon /> <span className="ml-3">{t("HEADER.BUTTONTEXT.ADMINPANEL")}</span>
//                                 </a>
//                             ) : null}
//                             <a href="/profile"
//                                class={`list-group-item list-group-item-action${getMenuItemActive("/profile") ? " active" : ""}`}>
//                                 <AssignmentIndIcon /> <span className="ml-3">{t("HEADER.BUTTONTEXT.PROFILE")}</span>
//                             </a>
//                             <button onClick={onClickLogout} class="list-group-item list-group-item-action">
//                                 <ExitToAppIcon />
//                                 <span className="ml-3">{t("HEADER.BUTTON.LOGOUT")}</span></button>
//                         </div>
//                     </div>
//                     : null}
//             </div>
//         );
//     }
// ;
//
// export default CollapsedMenu;
